import {objOf, thunkify} from 'ramda'
import {useDispatch} from 'react-redux'

export function useSimpleDispatch(type) {
  return useDelayedDispatch(objOf('type', type))
}

export function useDelayedDispatch(...args) {
  return thunkify(useDispatch())(...args)
}